import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./index.css";
import i18n from "./i18n";
import VueScrollTo from "vue-scrollto";

createApp(App).use(VueScrollTo).use(i18n).use(store).use(router).mount("#app");